import React from 'react';
import styles from './index.module.scss';

const DownArrowIcon: React.FC = () => {
  return (
    <div className={styles.icon} title="down arrow" role="img"/>
  );
}

export default DownArrowIcon;
